import { PreviewCard } from '@aibees/elephant/components/backoffice/preview-card';
import { styled } from '@mui/material/styles';

export const Wrapper = styled(PreviewCard)``;

export const Logo = styled('img')`
  width: ${(p) => p.theme.spacing(2)};
`;
